export default {"src":"/_next/static/media/profile-details.4583d155.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};